import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { initializeGTM } from "@/lib/analytics";
import { usePageTracking } from "@/hooks/use-analytics";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import SolucionesEmpresariales from "./pages/SolucionesEmpresariales";
import InboundMarketing from "./pages/InboundMarketing";
import DesarrolloMovil from "./pages/DesarrolloMovil";
import QuienesSomos from "./pages/QuienesSomos";
import Contacto from "./pages/Contacto";
import InteligenciaArtificial from "./pages/InteligenciaArtificial";
//import CarouselDemo from "./pages/CarouselDemo";
import ImageCarousel from "@/components/ImageCarousel";

const queryClient = new QueryClient();

const AnalyticsWrapper = ({ children }: { children: React.ReactNode }) => {
  usePageTracking();
  return <>{children}</>;
};

const App = () => {
  useEffect(() => {
    const gtmId = import.meta.env.VITE_GTM_ID;

    if (gtmId) {
      initializeGTM(gtmId);
    } else {
      console.warn('VITE_GTM_ID no está configurado en el archivo .env');
    }
  }, []);

  return (
    <HelmetProvider>
      <GoogleReCaptchaProvider
        reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY || ""}
      >
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <AnalyticsWrapper>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/privacidad" element={<Privacy />} />
                  <Route path="/terminos" element={<Terms />} />
                  <Route path="/soluciones-empresariales" element={<SolucionesEmpresariales />} />
                  <Route path="/inbound-marketing" element={<InboundMarketing />} />
                  <Route path="/desarrollo-movil" element={<DesarrolloMovil />} />
                  <Route path="/quienes-somos" element={<QuienesSomos />} />
                  <Route path="/contacto" element={<Contacto />} />
                  <Route path="/inteligencia-artificial" element={<InteligenciaArtificial />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </AnalyticsWrapper>
            </BrowserRouter>
          </TooltipProvider>
        </QueryClientProvider>
      </GoogleReCaptchaProvider>
    </HelmetProvider>
  );
};

export default App;
